<template>
  <FilterSingleChip
    is-text
    :label-mode="labelMode"
    icon="file-text"
    :label="$t('search-filters.documents')"
    :items="items"
    :value="value"
    @change="$emit('change', $event)"
  />
</template>

<script>
import FilterSingleChip from '@/components/filters/FilterSingleChip';
import { LABEL_MODE } from '@/components/filters/label-mode';
import { DOCUMENT_FILTERS } from '@/models/search-filters';

/**
 * Document dimension chip (with / without attachment). Presentational: `:value` (boolean|null)
 * in, `change` out. Single-select with boolean values; null means no filter. Icon chip — the
 * label doubles as the hover tooltip.
 */
export default {
  name: 'DocumentChip',
  components: { FilterSingleChip },
  props: {
    value: { type: Boolean, default: null },
  },
  computed: {
    labelMode: () => LABEL_MODE.VALUE,
    items() {
      return Object.entries(DOCUMENT_FILTERS).map(([key, value]) => ({
        value,
        text: this.$t(`search-filters.action-filters.values.${key.toLowerCase().replace('_', '-')}`),
      }));
    },
  },
};
</script>
